import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { EventBusService } from '../../event-bus.service';
import { AccountService } from '../../model/account/account.service';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { environment } from '../../../environments/environment';
import { InputComponent } from '../../shared/input/input.component';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PermissionService } from '../../permissions.service';
import { signIn } from 'aws-amplify/auth';
import { LocalizationService } from '../../shared/localization.service';

@Component({
  selector: 'app-login-page',
  standalone: true,
  providers: [MessageService],
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    IconFieldModule,
    InputIconModule,
    ButtonModule,
    ToastModule,
    InputComponent,
    ReactiveFormsModule,
    RouterLink,
  ],
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent {
  errorMessage: string | null = null;
  resetPasswordUrl: string;

  loginForm: FormGroup;

  constructor(
    private router: Router,
    private eventBusService: EventBusService,
    private accountService: AccountService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private permissionService: PermissionService,
    private localizationService: LocalizationService
  ) {
    const clientId = 'account-console';
    this.resetPasswordUrl = `${environment.keycloakUrl}/login-actions/reset-credentials?client_id=${clientId}`;

    this.loginForm = this.fb.group({
      username: [null, Validators.required],
      password: [null, Validators.required]
    });

    this.localizationService.applicationRedirect('login');
  }

  async login() {
    try {
      this.errorMessage = null;

      const response = await signIn({
        username: this.loginForm.value.username,
        password: this.loginForm.value.password,
      });

      const success = response.isSignedIn;
      const signInStep = response.nextStep?.signInStep;

      if (success) {
        const account = await this.accountService.fetch();

        this.permissionService.reloadRolesAndPermissions();

        this.router.navigate(['/']);

        this.eventBusService.publish('user:login', this.loginForm.value.username);
      } else if (signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
        this.router.navigate(['/new-password']);
      } else {
        this.messageService.add({
          severity: 'error',
          summary: $localize`:@@login.failedSummary:Login Failed`,
          detail: $localize`:@@login.failedDetail:Invalid credentials or an error occurred during login.`,
          closable: true,
          icon: 'ri-error-warning-fill'
        });
      }
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: $localize`:@@login.failedSummary:Login Failed`,
        detail: $localize`:@@login.failedDetail:Invalid credentials or an error occurred during login.`,
        closable: true,
        icon: 'ri-error-warning-fill'
      });
    }
  }
}
